<template>
    <input
        v-model="inputVal"
        :type="type"
        :class="getClasses()"
        class="intro-x login__input form-control py-3 px-4 border-gray-300 block"
        :placeholder="hint"
    />
    <div v-if="isInvalid" class="text-theme-6 mt-2">This field is required</div>
</template>

<script>
export default {
    name: "HintInput",
    props: {
        modelValue: String,
        isInvalid: Boolean,
        hint: String,
        type: {
            type: String,
            default: 'text'
        },
        extraClass: {
            type: Array,
            default: []
        }
    },
    emits: ['update:modelValue'],
    methods: {
        getClasses(){
            return this.isInvalid ? [
                'border-theme-6',
                ...this.extraClass
            ] : this.extraClass;
        }
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        }
    }
}
</script>
